/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import {
	getObjectValueIfExists,
	getObjectValuesIfExists,
} from 'modules/utilities/Helpers';
import {
	ICreateNotification,
	INotificationDetails,
} from '../interfaces/notification';

export class NotificationsService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getNotificationById(notificationId: number) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_NOTIFICATIONS
						.GET_NOTIFICATION,
					null,
					{ reqPathParam: notificationId },
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				}),
		);
	}
	addNotification(newNotificationData: INotificationDetails) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_NOTIFICATIONS
						.ADD_NOTIFICATION,
					this.formatNotificationReqData(newNotificationData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	updateNotification(notificationToUpdateData: INotificationDetails) {
		return new Promise((resolve, reject): Promise<void> => {
			return this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_NOTIFICATIONS
						.UPDATE_NOTIFICATION,
					this.formatNotificationReqData(notificationToUpdateData),
				)
				.then((result: any) => {
					resolve(result);
				})
				.catch((error: any) => {
					reject(error);
				});
		});
	}
	getAllNotifications(page?: number) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_NOTIFICATIONS
						.GET_NOTIFICATIONS,
					{},
					{
						pathParams: { page: page || 1 },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}
	deleteNotification(notificationId: number) {
		return this.apiService.invoke(
			this.applicationContext.getApiConfig().END_USERS_NOTIFICATIONS
				.DELETE_NOTIFICATION,
			null,
			{ reqPathParam: notificationId },
		);
	}

	searchUsersQuestionsAnswers(searchKey?: string) {
		return new Promise((resolve, reject) => {
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().END_USERS_NOTIFICATIONS
						.SEARCH_USERS_QUESTIONS_ANSWERS,
					{},
					{
						pathParams: { searchKey },
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((error: Error) => {
					reject(error);
				});
		});
	}
	private formatNotificationReqData(
		notificationData: INotificationDetails,
	): ICreateNotification {
		return {
			...(notificationData.id ? { id: notificationData.id } : {}),
			title: notificationData.title,
			description: notificationData.description,
			isDraft: notificationData.isDraft,
			endUsersFilter: {
				...getObjectValueIfExists(
					notificationData.endUsersFilter,
					'gender',
					-1,
				),
				...getObjectValueIfExists(
					notificationData.endUsersFilter,
					'currentRegion',
					-1,
				),
				...getObjectValueIfExists(
					notificationData.endUsersFilter,
					'createdDateFrom',
				),
				...getObjectValueIfExists(
					notificationData.endUsersFilter,
					'createdDateTo',
				),

				...getObjectValueIfExists(
					notificationData.endUsersFilter,
					'countryCode',
				),
				...getObjectValueIfExists(
					notificationData.endUsersFilter,
					'lastInteractionDateFrom',
				),
				...getObjectValueIfExists(
					notificationData.endUsersFilter,
					'lastInteractionDateTo',
				),
				onboardingQuestionAnswerFilters:
					notificationData.endUsersFilter.onboardingQuestionAnswerFilters,
				fromLessonId: notificationData.filterFromLesson?.id,
				toLessonId: notificationData?.filterToLesson?.id,
			},
			...getObjectValuesIfExists(notificationData, 'scheduledAt', [
				undefined,
				'',
			]),
			...getObjectValueIfExists(notificationData, 'redirectToScreen', -1),

			tagId: notificationData.tag?.id,
		};
	}
}
